/// <amd-module name="VSSUI/TagPicker" />
export * from "./Components/TagPicker/TagPicker";
export { ISelectedTagProps, ITagPickerProps } from "./Components/TagPicker/TagPicker.Props";
